// extracted by mini-css-extract-plugin
module.exports = {"select":"XosImage_select__3Oqak","row":"XosImage_row__39oMB","button":"XosImage_button__2dKc-","input":"XosImage_input__16s43"};